export default __webpack_public_path__ + "static/media/12.f4ee1b54.jpg";